module.exports = __webpack_public_path__ + "media/images/porque/art-security-privacity-4b23448a3dc883fcb2de4288e4d4c4af.svg";